import { SharedListingProps } from "../types";

export const createSharedListingProps = (
  props: SharedListingProps,
): SharedListingProps => {
  return {
    category: props.category,
    emailShare: props.emailShare,
    fbShare: props.fbShare,
    isFav: props.isFav,
    isMDScreen: props.isMDScreen,
    listingId: props.listingId,
    metro: props.metro,
    toggleFavorite: props.toggleFavorite,
    twitterShare: props.twitterShare,
    useType: props.useType,
  };
};
